'use strict';

module.exports = '3.20.4';



//////////////////
// WEBPACK FOOTER
// /tmp/~/algoliasearch/src/version.js
// module id = 586
// module chunks = 0